// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._bozgv77o{padding-inline-start:var(--ds-space-025,2px)}\n._syaz1ml5{color:var(--_1xw92dq)}", ""]);
// Exports
module.exports = exports;
